export enum EnumLogicQuery {
  LogicQueryAllAnd = "ALL_AND",
  LogicQueryAllOr = "ALL_OR",
  LogicQueryAllCustomLogic = "CUSTOM_LOGIC",
}
